<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Akte {{versichertenNr}}</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="
    height: Calc(90vh - 50px);
">
  <iframe [src]="url()" style="width: 100%; height: 100%;"></iframe>
</div>
